import React from "react";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function TheArchiformaStandard() {
  const standards = [{
    id: "01",
    title: "Technical Precision",
    description: "Our engineering team ensures every structural element meets rigorous safety standards while maintaining the aesthetic purity of the original architectural vision."
  }, {
    id: "02",
    title: "Material Excellence",
    description: "We source high-grade concrete, steel, and sustainable timber to guarantee longevity and tactile quality in every residential and commercial project."
  }];
  return <section data-section-id="254264" id="the-archiforma-standard" className="bg-pure-white py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          
          {}
          <div className="order-2 lg:order-1 lg:col-span-6 relative group">
            <div className="relative aspect-[4/5] lg:aspect-[3/4] rounded-lg overflow-hidden shadow-depth">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689812/img/architectural_structural_integrity.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689812/img/architectural_structural_integrity.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689812/img/architectural_structural_integrity.png-wvc-sizes" alt="Modern architectural construction site with structural beams" className="object-cover w-full h-full grayscale group-hover:grayscale-0 transition-all duration-700 ease-out scale-105 group-hover:scale-100" loading="lazy" decoding="async" />
              <div className="absolute inset-0 bg-obsidian/10 group-hover:bg-transparent transition-colors duration-500" />
            </div>
            
            {}
            <div className="absolute -bottom-6 -right-6 bg-gold-ochre p-8 rounded-lg shadow-elevation hidden md:block">
              <div className="flex flex-col gap-2">
                <span className="text-[10px] font-mono font-bold tracking-widest uppercase text-white/80">
                  Standard No.
                </span>
                <span className="text-3xl font-mono font-bold text-white leading-none">
                  2007-AF
                </span>
              </div>
            </div>
          </div>

          {}
          <div className="order-1 lg:order-2 lg:col-span-6">
            <div className="max-w-xl">
              <div className="flex items-center gap-3 mb-6">
                <div className="h-px w-8 bg-gold-ochre" />
                <span className="text-xs font-mono font-bold tracking-widest uppercase text-gold-ochre">
                  01 / 03 — Our Process
                </span>
              </div>
              
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-onyx font-default mb-8 leading-tight tracking-tight">
                The ArchiForma Standard
              </h2>
              
              <div className="space-y-10 mb-12">
                {standards.map((item, i) => <div key={item.id} data-index={i} className="group">
                    <div className="flex items-start gap-6">
                      <div className="mt-1">
                        <Plus className="size-5 text-gold-ochre" strokeWidth={2.5} />
                      </div>
                      <div className="flex-1 border-b border-concrete/30 pb-8">
                        <h3 className="text-xl font-bold font-default uppercase tracking-wide text-onyx mb-3 group-hover:text-gold-ochre transition-colors duration-300">
                          {item.title}
                        </h3>
                        <p className="text-lg text-muted-foreground leading-relaxed font-sans">
                          {item.description}
                        </p>
                      </div>
                    </div>
                  </div>)}
              </div>

              <Link to="/HomePage">
                <Button size="lg" className="bg-gold-ochre text-white hover:bg-gold-ochre/90 text-sm px-10 py-7 rounded-lg shadow-elevation font-mono uppercase tracking-widest transition-all duration-300 hover:-translate-y-1">
                  View Our Portfolio
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}